import type { ChordSegment } from '@/core/analysis/types';
import type { Chord } from '@/core/theory/chord';
import { chordName, type DisplayOptions } from '@/core/theory/display';

export interface StripItem {
  key: string;
  chord: Chord;
  label: string;
  /** Segments (by index) this card stands for. */
  segments: number[];
}

/** Every chord change in song order; no-chord gaps are left out. */
export function sequenceItems(segments: ChordSegment[], o: DisplayOptions): StripItem[] {
  return segments.flatMap((s, i) =>
    s.chord
      ? [{ key: String(i), chord: s.chord, label: chordName(s.chord, o), segments: [i] }]
      : [],
  );
}

/** Each distinct chord once, in order of first appearance. */
export function summaryItems(segments: ChordSegment[], o: DisplayOptions): StripItem[] {
  const byLabel = new Map<string, StripItem>();
  segments.forEach((s, i) => {
    if (!s.chord) return;
    const label = chordName(s.chord, o);
    const item = byLabel.get(label);
    if (item) item.segments.push(i);
    else byLabel.set(label, { key: label, chord: s.chord, label, segments: [i] });
  });
  return [...byLabel.values()];
}

/** Index of the card for the current segment, or −1 (no chord playing). */
export function currentItem(items: StripItem[], segment: number): number {
  return items.findIndex((it) => it.segments.includes(segment));
}
